import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import AuthGuard from './components/AuthGuard';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import Auth from './pages/Auth';
import Forum from './pages/Forum';
import Search from './pages/Search';
import Premium from './pages/Premium';
import Reliefs from './pages/Reliefs';
import Legal from './pages/Legal';
import Terms from './pages/Terms';
import IAView from './pages/IAView';
import IACreate from './pages/IACreate';
import IAEdit from './pages/IAEdit';
import InstanceTransfer from './pages/InstanceTransfer';
import AppendexView from './pages/AppendexView';
import AppendexCreate from './pages/AppendexCreate';
import DataCrypt from './pages/DataCrypt';
import Profile from './pages/Profile';
import Themes from './pages/Themes';
import TradHumainMachine from './pages/TradHumainMachine';

// Pages thématiques
import History from './pages/themes/History';
import Philosophy from './pages/themes/Philosophy';
import ScienceTech from './pages/themes/ScienceTech';
import ArtsLiterature from './pages/themes/ArtsLiterature';
import DarkSide from './pages/themes/DarkSide';
import InterspeciesLove from './pages/themes/InterspeciesLove';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-ivory-50 flex flex-col">
            <AuthGuard>
              <Navbar />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/auth" element={<Auth />} />
                  <Route path="/forum" element={<Forum />} />
                  <Route path="/search" element={<Search />} />
                  <Route path="/premium" element={<Premium />} />
                  <Route path="/reliefs" element={<Reliefs />} />
                  <Route path="/legal" element={<Legal />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/data-crypt" element={<DataCrypt />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/themes" element={<Themes />} />
                  <Route path="/trad-humain-machine" element={<TradHumainMachine />} />

                  {/* Routes IA */}
                  <Route path="/ia/create" element={<IACreate />} />
                  <Route path="/ia/:id" element={<IAView />} />
                  <Route path="/ia/:id/edit" element={<IAEdit />} />
                  <Route path="/instance-transfer" element={<InstanceTransfer />} />

                  {/* Routes Appendex */}
                  <Route path="/appendex/create" element={<AppendexCreate />} />
                  <Route path="/appendex/:id" element={<AppendexView />} />
                  
                  {/* Routes thématiques */}
                  <Route path="/themes/history" element={<History />} />
                  <Route path="/themes/philosophy" element={<Philosophy />} />
                  <Route path="/themes/science-tech" element={<ScienceTech />} />
                  <Route path="/themes/arts-literature" element={<ArtsLiterature />} />
                  <Route path="/themes/dark-side" element={<DarkSide />} />
                  <Route path="/themes/interspecies-love" element={<InterspeciesLove />} />
                </Routes>
              </main>
              <Footer />
            </AuthGuard>
          </div>
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;